import React from 'react';
import { BellIcon, CameraIcon, IdCardIcon, KeyRoundIcon, MapPinIcon } from 'lucide-react';
import { appBenefits } from '../../data/espace';
import { PhoneMockup } from './PhoneMockup';
const benefitIcons = {
  card: IdCardIcon,
  bell: BellIcon,
  pin: MapPinIcon,
  camera: CameraIcon,
  key: KeyRoundIcon
};
function QrCode() {
  const cells = ['111111011010111111', '100001010110100001', '101101001010101101', '101101011100101101', '100001000110100001', '111111010101111111', '000000011100000000', '110101101011010110', '001011000110101001', '110010111001010110', '011101001101101001', '000000010011010110', '111111011010101001', '100001001101010110', '101101010011101001', '101101101100010110', '100001011011101001', '111111010101010110'];
  return <svg viewBox="0 0 18 18" className="h-28 w-28" role="img" aria-label="Code QR pour télécharger l’application" data-id="element-1453" data-mp="145v7f3dwcj8a">
      <rect width="18" height="18" fill="#ffffff" data-id="element-1454" data-mp="z837pn70fstj" />
      {cells.map((row, y) => row.split('').map((cell, x) => cell === '1' ? <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="var(--ville-navy)" data-id="element-1455" data-mp="2gf1renwrnyeq" /> : null))}
    </svg>;
}
export function AppPromo() {
  return <section aria-labelledby="app-titre" className="mt-16 grid gap-10 rounded-3xl border border-slate-200 bg-slate-50 p-6 sm:p-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center" data-id="element-1456" data-mp="2lcl7zugxsn9u">
      <div data-id="element-1457" data-mp="2v6k52f25lgux">
        <h2 id="app-titre" className="text-3xl font-extrabold tracking-tight text-ville-navy" data-id="element-1458" data-mp="303aoncd62ul3">
          Votre espace, partout avec vous.
        </h2>
        <p className="mt-3 max-w-xl text-[17px] leading-relaxed text-slate-600" data-id="element-1459" data-mp="345fctvkuiz0c">
          Retrouvez votre carte, vos alertes et vos services dans l’application bciti+ de la Ville de Beaconsfield.
        </p>

        <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-1460" data-mp="19spi5bmnllrw">
          {appBenefits.map(benefit => {
          const Icon = benefitIcons[benefit.icon];
          return <li key={benefit.id} className="flex items-center gap-3 text-sm text-slate-600" data-id="element-1461" data-mp="2i1wu20wynggn">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-1462" data-mp="2d2tvmzbhk8hn">
                  <Icon className="h-4 w-4" data-id="element-1463" data-mp="2qzgtr5f6d4p5" />
                </span>
                {benefit.label}
              </li>;
        })}
        </ul>

        <div className="mt-8 flex flex-wrap items-center gap-5" data-id="element-1464" data-mp="30yxx3g6yf6hy">
          <div className="rounded-2xl border border-slate-200 bg-white p-3" data-id="element-1465" data-mp="2w0o338wyubxx">
            <QrCode data-id="element-1466" data-mp="2vyk14wimnn0a" />
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-1467" data-mp="39skqiznovxnz">
            <a href="#app" className="inline-flex items-center rounded-full bg-ville-navy px-6 py-3 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1468" data-mp="39r9nj222itxx">
              Télécharger l’app
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-1469" data-mp="2831o5z2dpy4">
              App Store
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-1470" data-mp="3tfxm41l11hvg">
              Google Play
            </a>
          </div>
        </div>
      </div>

      <PhoneMockup data-id="element-1471" data-mp="3anv4oo0k9xk5" />
    </section>;
}